import { cn } from "@/lib/utils";

export function DemoBadge({ className }) {
  return (
    <span
      data-testid="demo-badge"
      className={cn(
        "inline-flex items-center gap-1 bg-amber-500/10 text-amber-400 border border-amber-500/30 text-[10px] font-mono px-1.5 py-0.5 rounded uppercase font-semibold tracking-wide",
        className
      )}
    >
      ● Demo
    </span>
  );
}
